// Mettre à false pour déployer sans la fonctionnalité visible (tests) : filtre "Décisions administratives" de la
// modale de recherche masqué pour tous, et encart de nouveauté non affiché.
export const FEATURE_FLAGS = {
  decisionsAdmin: false
};
